import React, { useRef, useState } from "react";
import loanRs from "../../../assets/Images/Home/loan-rs.svg";
import creditScoreSvg from "../../../assets/Images/Home/credit-score.svg";

import instaLoan from "../../../assets/Images/Home/instaLoan.jpg";
import FAQAccordion from "./Accordian";
import { emiCalculatorValue } from "./SvgIcon";
import groupImage from "../../../assets/Images/Home/Group-425.jpg";
import TextImageSection from "../../Home/component/TextImageSection";
import Vector from "../../../assets/Images/Home/Vector.jpg";
import GroupThree from "../../../assets/Images/Home/Group-3.jpg";
import greenStar from "../../../assets/Images/Home/green-star.jpg";
import blueStar from "../../../assets/Images/Home/blue-star.jpg";
import Dashboard from "../../../assets/Images/Home/Dashboard.jpg";
import Navbar from "../../../components/Navbar";
import ContactIcon from "../../../assets/Images/component/contactIcon.svg";
import EligibilityCriteria from "../../../assets/Images/Home/EligibilityCriteria.png";
import DocumnetReq from "../../../assets/Images/Home/Documnet-req.png";
import creditScore from "../../../assets/Images/Home/creditScore.png";
import LoanProduct from "../../../components/LoanProducts";
import EMICalculator from "../../../components/EMICalculator.js";
import MaskGroup from "../../../assets/Images/Home/MaskGroup.svg";
import CreditScoreChecker from "../../../components/CreaditScore/CreditScoreChecker";
import Slider from "../../../components/Slider/Slider";
import DivSLider from "../../../components/Slider/DivSlider";
import CreditScoreMeter from "../../../components/CreditScoreNew";
import ImageSliderpopup from "../../../components/Slider/ImagePopupSlider/ImageSliderPopup";
import checkIfUserCanApplyLoan from "../../../Utils/customHooks/useCheckIfUserCanApply"
import Scroller from "../../../components/Slider/Scroller.js";
const Products = [
  {
    title: "Eligibility Criteria",
    icon: ContactIcon,
    image: EligibilityCriteria,
    list: ["Age 21- 65", "Employment status"],
    color: {
      iconBg: "#DECEE5",
      contentBg: "#DECEE5",
      borderColor: "#6F4C9F",
    },
  },
  {
    title: "Documents Required",
    icon: ContactIcon,
    image: DocumnetReq,
    list: ["Pan card", "Aadhar card", "Address proof"],
    color: {
      iconBg: "#F0EFA2",
      contentBg: "#F0EFA254",
      borderColor: "#AB882E",
    },
  },
  {
    title: "Credit Score",
    icon: ContactIcon,
    image: creditScore,
    list: ["Age 21- 65", "Employment status"],
    color: {
      iconBg: "#9BD7D0",
      contentBg: "#9BD7D033",
      borderColor: "#9BD7D0",
    },
  },
];

const HomePage = ({ }) => {
  const scrollRef = useRef(null)
  const [activeSection, setActiveSection] = useState("creditScorevalue")
  // Scroll left or right
  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  const applyNow = checkIfUserCanApplyLoan();
  return (
    <>

      <div className="home-section flex justify-center items-center min-h-[100vh]">
        <div className="info-section">
          <div className="content-info">
            <h1 className="heading-light">Life moves fast, </h1>
            <h1 className="heading-dark">so should you</h1>

            <p className="decription">
              In today's fast-paced world, financial needs can arise
              unexpectedly, and your finances should keep up with life's
              demands. Embrace the speed of life with confidence.
            </p>

            <button className="apply-button" onClick={()=>applyNow()} >
              <span className="button-text">Apply Now</span>
            </button>
          </div>
          <div className="image-info">
            <img src={groupImage}></img>
          </div>
        </div>
        <TextImageSection
          view={"image-with-overlap-text"}
          image={Vector}
          heading={"Fast. Simple. Secure."}
          custumeClass="center-section"
        ></TextImageSection>

        <TextImageSection
          view={"heading-then-image"}
          image={GroupThree}
          heading={"Lending Partner"}
          custumeClass="center-section leading-partner"
        ></TextImageSection>

        <div className="info-section small-heading-section">
          <div className="content-info">
            <h1 className="heading-light">About Us</h1>
            <p className="decription">
              At FastFin, we recognize the challenges of unexpected expenses and
              aim to break through traditional banking barriers to provide
              timely. Whether it's an emergency expense or an opportunity that
              requires immediate funding, we help you navigate life's challenges
              with ease.{" "}
            </p>
          </div>
          <div className="image-info">
            <div className="info-section-box">
              <img
                className="image-section-image"
                src={greenStar}
                alt="Example"
              />
              <h1>Loans For Your Urgent Needs</h1>
              <p>Get Fast Approval in 10 Minutes!</p>
            </div>
            <div className="info-section-box second-box">
              <img
                className="image-section-image"
                src={blueStar}
                alt="Example"
              />
              <h1>Loans For Your Urgent Needs</h1>
              <p>Get Fast Approval in 10 Minutes!</p>
            </div>
          </div>
        </div>
      </div>
      <div className="color-section home-section flex justify-center items-center min-h-[100vh]">

        <ImageSliderpopup imageArr={[Dashboard, Dashboard, Dashboard]} />
        <div class="heading-then-image center-section leading-partner dashboard-section">
          <div class="image-overlaping-text">
            <h1 class="first-line-heading">Everything</h1>
            <h1 class="second-line-heading">You Need to know</h1>
          </div>
          <Scroller>
            {Products?.map((item) => (
              <LoanProduct
                icon={item?.icon}
                title={item?.title}
                thumbnail={item?.image}
                list={item?.list}
                color={item?.color}
              />
            ))}
         </Scroller>
        </div>
      </div>
      <div className="home-section flex justify-center items-center min-h-[100vh]">
        <Slider interval={4000}>
          <TextImageSection
            view={"heading-then-image"}
            image={MaskGroup}
            heading={"Loans for Your Urgent Needs"}
            headingSecond={"Approved in 10 Minutes!"}
            loader={true}
            custumeClass="center-section leading-partner image-hr-text"
          ></TextImageSection>
          <TextImageSection
            view={"heading-then-image"}
            image={MaskGroup}
            loader={true}
            heading={"Just a Simple Application."}
            headingSecond={"5 Easy Steps to Your happiness!"}
            custumeClass="center-section leading-partner image-hr-text"
          ></TextImageSection>
          <TextImageSection
            view={"heading-then-image"}
            image={MaskGroup}
            loader={true}
            heading={"Loans for Your Urgent Needs"}
            headingSecond={"Approved in 20 Minutes!"}
            custumeClass="center-section leading-partner image-hr-text"
          ></TextImageSection>
        </Slider>

        <div className="sub-nav-button-sreen">
          <div className="navigation-menu">
            <div
              className={`${activeSection === "creditScorevalue" ? "active-chip" : ""
                } chip-group`}
              onClick={() => setActiveSection("creditScorevalue")}
            >
              <img src={creditScoreSvg} alt={"credit score"}></img>
              <p className="chip-heading">Check credit score</p>
            </div>
            <div
              className={`${activeSection === "emiCalculator" ? "active-chip" : ""
                } chip-group`}
              onClick={() => setActiveSection("emiCalculator")}
            >
              {emiCalculatorValue}
              <p className="chip-heading">EMI calculator</p>
            </div>
            <div
              className={`${activeSection === "loanRs" ? "active-chip" : ""
                } chip-group`}
              onClick={() => setActiveSection("loanRs")}
            >
              <img src={loanRs} alt={"credit score"}></img>
              <p className="chip-heading">Apply for loan</p>
            </div>
          </div>
          <div className="section-content">
            <div
              className={`${activeSection === "creditScorevalue" ? "active" : ""
                } section-content-value`}
            >
              <CreditScoreMeter />
            </div>
            <div
              className={`${activeSection === "emiCalculator" ? "active" : ""
                } section-content-value`}
            >
              <EMICalculator />
            </div>

            <div
              className={`${activeSection === "loanRs" ? "active" : ""
                } section-content-value`}
            >
              <DivSLider />
            </div>
          </div>
        </div>

        <TextImageSection
          view={"heading-then-image"}
          image={instaLoan}
          heading={"Instant loan to move up in life"}
          // headingSecond={"Approved in 10 Minutes!"}
          button="Apply Now"
          custumeClass="center-section leading-partner image-hr-text insta-loan"
        ></TextImageSection>
      </div>

      <div className="heading-with-accordian">
        <div className="heading-accordian">
          <h1 className="light-heading">Explore Loan Products</h1>
          <h1 className="dark-heading">Quick Loans for Every Goals. </h1>
          <h1 className="dark-heading">Get Yours Today!</h1>
        </div>
        <DivSLider />
        <FAQAccordion></FAQAccordion>
      </div>
    </>
  );
};

export default HomePage;
